export default "__VITE_ASSET__DkN0W8rb__"